export const home = {
  heroTitle: "Digitales Archiv deutscher Websites",
  heroDescription:
    "Durchsuchen, entdecken und kategorisieren Sie deutsche Websites. Eine gemeinsame Plattform fuer Bibliotheken zur systematischen Erfassung und Archivierung digitaler Inhalte.",
  search: "Suchen",
  aiSearching: "Suche...",
  aiSearchToggleLabel: "KI-Suche",
  aiSearchStatusOn: "AN",
  aiSearchStatusOff: "AUS",
  aiSearchStatusForcedOff: "ERZWUNGEN AUS (Admin)",
  aiSearchStatusHintOn:
    "Natürliche Sprache wird aktiv in Kategorie-, Regions- und Textfilter aufgeteilt.",
  aiSearchStatusHintOff:
    "Nur Textsuche aktiv. Schalten Sie die KI-Suche ein, um Kategorien und Regionen automatisch zu erkennen.",
  aiSearchStatusHintForcedOff:
    "Die KI-Suche ist per Systemeinstellung deaktiviert. Ihre Präferenz bleibt gespeichert.",
  aiSearchTurnOn: "KI-Suche einschalten",
  aiSearchTurnOff: "KI-Suche ausschalten",
  aiSearchToggleHint:
    "Natürliche Suchsätze werden automatisch in Kategorie-, Regions- und Textfilter aufgeteilt (inkl. Mehrfachregionen, Makroregionen und PLZ).",
  aiSearchDisabled:
    "Die KI-Suche ist derzeit durch eine Systemeinstellung deaktiviert.",
  aiSuggestionDistrictPairDe: "Museum in Niederbayern oder Oberbayern",
  aiSuggestionVicinityDe: "Familienzentrum in der Nähe von Niederbayern",
  aiSuggestionMacroRegionDe: "Kinderarzt in Südbayern",
  aiSuggestionDescriptive:
    "Beratungsstelle rund um München mit Online-Angebot",
  aiSuggestionBrandDe: "4benefits Fitnessstudio in Bayern",
  aiSuggestionTyposDe: "fitnesstudio in da nähe von münchen",
  aiSuggestionDistrictPairEn: "museum in Lower Bavaria or Upper Bavaria",
  aiSuggestionVicinityEn:
    "family support center in the vicinity of Lower Bavaria",
  aiSuggestionMacroRegionEn: "pediatrician in Southern Bavaria",
  aiSuggestionBrandEn: "4benefits fitness studio in Bavaria",
  aiSuggestionMixedDeEn: "eine Schule rund um München mit digitalem Lernen",
  browseCategories: "Nach Kategorien durchsuchen",
  viewStatistics: "Statistiken ansehen",
  statsWebsites: "Websites",
  statsCategories: "Kategorien",
  statsUsers: "Registrierte Nutzer",
  featuresTitle: "Funktionen",
  featuresDescription:
    "WebKurator.de bietet umfassende Werkzeuge zur Verwaltung und Kategorisierung deutscher Websites für Archivierungszwecke.",
  featureAdvancedSearch: "Erweiterte Suche",
  featureAdvancedSearchDesc:
    "Durchsuchen Sie tausende archivierte Websites nach Titel, Inhalt oder Kategorie mit leistungsstarken Filtern.",
  featureCategorization: "Kategorisierung",
  featureCategorizationDesc:
    "Hierarchische Kategorisierung nach Themen und Regionen mit automatischen Vorschlägen durch Machine Learning.",
  featureCollaboration: "Zusammenarbeit",
  featureCollaborationDesc:
    "Gemeinsame Plattform für nationale, staatliche und regionale Bibliotheken zur effizienten Zusammenarbeit.",
  featureLongTermArchiving: "Langzeitarchivierung",
  featureLongTermArchivingDesc:
    "Sichere Archivierung digitaler Inhalte im Rahmen des Projekts an der Universität Passau.",
  featureStatistics: "Statistiken",
  featureStatisticsDesc:
    "Detaillierte Einblicke in den Datenbestand mit automatisch generierten Statistiken und Berichten.",
  featurePublicAccess: "Öffentlicher Zugang",
  featurePublicAccessDesc:
    "Barrierefrei und öffentlich zugänglich für Forschung, Bildung und allgemeine Nutzung.",
  ctaTitle: "Werden Sie Teil des Projekts",
  ctaDescription:
    "Registrieren Sie sich, um Websites hinzuzufügen, zu kategorisieren und zur Qualität des digitalen Archivs beizutragen.",
  ctaRegister: "Jetzt registrieren",
  ctaSuggest: "Website vorschlagen",
  ctaLogin: "Anmelden",
};

export const categories = {
  title: "Kategorien",
  subtitle: "Durchsuchen Sie Websites nach Kategorien",
  websites: "Websites",
  subcategories: "Unterkategorien",
  browse: "Kategorien durchsuchen",
  browseDescription:
    "Klicke auf eine Kategorie, um zu filtern. Unterkategorien sind ggf. verfügbar.",
  thematic: "Thematisch",
  thematicFilterHeading: "Thematisch filtern",
  regional: "Regional",
  regionalFilterHeading: "Regional filtern",
  back: "Zurück",
  inThisCategory: "Websites in dieser Kategorie",
  showSubcategories: "Unterkategorien",
  showResults: "Ergebnisse anzeigen",
  mostFrequent: "Häufigste Unterkategorien:",
  browseCategory: "Kategorie durchsuchen",
  showMore: "Unterkategorien anzeigen",
  germanyMap: "Deutschland Karte",
  germanyMapDescription:
    "Klicken Sie auf ein Bundesland, um Websites aus dieser Region zu sehen",
  interactiveMap: "Interaktive Deutschlandkarte",
  interactiveMapDescription:
    "In der vollständigen Version würde hier eine interaktive Karte der deutschen Bundesländer angezeigt werden",
  federalStates: "Bundesländer",
  totalWebsites: "Websites insgesamt",
  filterSort: "Filter & Sortierung",
  sortBy: "Sortieren nach",
  sortRelevance: "Relevanz",
  sortDateNew: "Neueste zuerst",
  sortDateOld: "Älteste zuerst",
  sortTitleAsc: "Titel A-Z",
  sortTitleDesc: "Titel Z-A",
  filterRegion: "Region",
  allRegions: "Alle Regionen",
  filterTime: "Zeitraum",
  allPeriods: "Alle Zeiträume",
  lastWeek: "Letzte Woche",
  lastMonth: "Letzter Monat",
  lastYear: "Letztes Jahr",
  searchInCategory: "In Kategorie suchen",
  openCategory: "Kategorie öffnen",
  germanyMapFilterTitle: "Deutschlandkarte – Filter nach Bundesland",
  germanyMapFilterDescription:
    "Klicke ein Bundesland an, um automatisch heranzuzoomen. Wenn dort Regierungsbezirke oder Kreise verfügbar sind, wird die passende Ebene sofort aktiviert, sodass du gezielt einzelne Regionen auswählen und die Ergebnisse filtern kannst.",
  resetSelection: "Auswahl zurücksetzen",
  allStatesSelected: "Alle Bundesländer ausgewählt",
  mapResolutionLabel: "Kartenauflösung",
  mapResolutionLow: "Niedrig (schnell)",
  mapResolutionLowDescription:
    "Vereinfachte Geometrien für einen schnellen Überblick auf jedem Gerät.",
  mapResolutionMedium: "Mittel (ausgewogen)",
  mapResolutionMediumDescription:
    "Bietet ausreichend Details bei moderater Dateigröße.",
  mapResolutionHigh: "Hoch",
  mapResolutionHighDescription:
    "Mehr Details bei weiterhin flüssiger Darstellung.",
  mapResolutionVeryHigh: "Sehr hoch (max. Detail)",
  mapResolutionVeryHighDescription:
    "Grenzen in voller Auflösung für präziseste Auswahlen.",
  mapResolutionWarning:
    "Die sehr hohe Auflösung enthält viele Details und kann ältere Geräte ausbremsen. Nur bei Bedarf verwenden.",
  panModeLabel: "Karte verschieben",
  panModeActive: "Verschieben aktiv",
  panModeHint:
    "Umschalttaste halten, dann ziehen oder scrollen zum Verschieben/Zoomen",
  panModeShiftKey: "Umschalttaste",
  zoomInLabel: "Vergrößern",
  zoomOutLabel: "Verkleinern",
  mapLayerLabel: "Wählbare Ebene",
  mapLayerCountry: "Deutschland",
  mapLayerCountryShort: "Deutschland",
  mapLayerCountryDescription:
    "Kompletter Deutschland-Umriss als Orientierung, nicht auswählbar.",
  mapLayerStates: "Bundesländer",
  mapLayerStatesShort: "Bundesländer",
  mapLayerStatesDescription:
    "Wähle Bundesländer wie Bayern, Hessen oder Berlin.",
  mapLayerAdministrative: "Regierungsbezirke",
  mapLayerAdministrativeShort: "Regierungsbezirke",
  mapLayerAdministrativeDescription:
    "Wähle Regierungsbezirke wie Niederbayern oder Oberfranken.",
  mapLayerDistricts: "Kreise",
  mapLayerDistrictsShort: "Kreise",
  mapLayerDistrictsDescription:
    "Wähle Landkreise oder kreisfreie Städte wie Freyung-Grafenau oder München.",
  mapLayerPostalCodes: "Postleitzahlen",
  mapLayerPostalCodesShort: "Postleitzahlen",
  mapLayerPostalCodesDescription: "Wähle Postleitzahlgebiete (PLZ) wie 94032.",
  mapPrecisionToggleLabel: "Präzisionsmodus",
  mapPrecisionToggleDescription:
    "Öffnet die Vollbildkarte für besonders genaue Auswahlen.",
  mapPrecisionActive: "Präzisionsmodus schließen",
  mapPrecisionDefault: "Präzisionsmodus öffnen",
  mapPrecisionOverlayTitle: "Präzise Auswahl",
  mapPrecisionOverlaySubtitle:
    "Vollbild-Deutschlandkarte für detaillierte Verwaltungsgebiete.",
  mapPrecisionOverlayHint:
    "Mit Schließen oder der Esc-Taste zurück zur Standardkarte.",
  selectionSummaryTitle: "Ausgewählte Regionen",
  mapDetailSectionTitle: "Weiter ins Detail",
  mapDetailSectionDescription:
    "Wähle eines der markierten Bundesländer, um Regierungsbezirke oder Kreise auszuwählen.",
  mapDetailStateLabel: "Fokussiertes Bundesland",
  mapDetailStatePlaceholder: "Bundesland auswählen",
  mapDetailLayerLabel: "Detailstufe",
  mapDetailLayerHint:
    "Regierungsbezirke bieten grobe Details, Kreise maximale Genauigkeit.",
  mapDetailLayerDisabled:
    "Bitte zuerst mindestens ein Bundesland auswählen, um Detail-Ebenen zu aktivieren.",
  mapDetailLayerClear: "Detailansicht zurücksetzen",
  resultsPerPage: "Ergebnisse pro Seite",
  paginationPrevious: "Zurück",
  activeFiltersTitle: "Filter aktiv:",
  clearAllFilters: "Alle Filter entfernen",
  activeQueryLabel: "Suchbegriff",
  activeCategoryLabel: "Kategorie",
  removeFilter: "Filter entfernen",
  searchTermPlaceholder: "Ergebnisse filtern...",
  jumpToPageLabel: "Seite auswählen",
  jumpToPagePlaceholder: "#",
  jumpToPageGo: "Zur Seite springen",
  regionSearchPlaceholder: "Bundesland, Kreis oder Postleitzahl eingeben...",
  regionSearchNoResults: "Keine passenden Regionen gefunden.",
  thematicSearchPlaceholder: "Kategorie eingeben...",
  thematicSearchNoResults: "Keine passenden Kategorien gefunden.",
  scrollUpHintTitle: "Zu thematischen & regionalen Filtern nach oben springen",
  scrollUpHintDescription:
    "Nutzen Sie die Schaltfläche, um direkt zu den Kategorien- und Kartenfiltern weiter oben zu springen.",
  scrollDownHintTitle: "Zur Textsuche nach unten springen",
  scrollDownHintDescription:
    "Hier klicken, um nach unten zum Suchfeld und den Ergebnisfiltern zu scrollen.",
  searchResultsTitle: "Suchergebnisse",
  searchResultsFound: "Gefunden",
  resultsSummary: "Zeige {{start}}-{{end}} von {{count}} Ergebnissen",
  lastSubcategorySelectedTitle: "Letzte Unterkategorie erreicht",
  lastSubcategorySelectedDescription:
    "Sie befinden sich in der letzten Unterkategorie: {{category}}.",
};

export const statistics = {
  title: "Statistiken",
  subtitle:
    "Detaillierte Einblicke in den Datenbestand und die Nutzung von WebKurator.de",
  overviewTab: "Uebersicht",
  totalWebsites: "Anzahl Websites",
  totalCategories: "Kategorien",
  totalCategoriesDetail: "gesamte Kategorien",
  activeUsers: "Registrierte Nutzer",
  registeredUsersDetail: "aktive Nutzerkonten",
  thisMonth: "Diesen Monat",
  newWebsites: "Neue Websites",
  topCategories: "Top Kategorien",
  recentActivity: "Letzte Aktivitaeten",
  mainCategories: "Hauptkategorien",
  avgPerWebsite: "Durchschnitt pro Website",
  categoriesPerWebsite: "Kategorien",
  last30Days: "in den letzten 30 Tagen",
  growth: "Wachstum",
  categoriesTab: "Kategorien",
  regions: "Regionen",
  engagementTab: "Engagement",
  overviewPanelTitle: "Plattform Uebersicht",
  overviewPanelDesc:
    "Schnelle, counter-basierte Kennzahlen. Die Tabs zeigen Wachstum, Kategorietiefe, regionale Verteilung und Engagement.",
  monthlyTrends: "Monatliche Trends",
  monthlyTrendsDesc: "Neue Websites und Nutzerregistrierungen pro Monat.",
  websiteGrowth: "Website-Wachstum",
  websiteGrowthDescription: "Anzahl der hinzugefuegten Websites pro Monat",
  userGrowth: "Nutzer-Wachstum",
  userGrowthDescription: "Anzahl neuer Nutzerregistrierungen pro Monat",
  newUsers: "Neue Nutzer",
  categoryDistribution: "Verteilung nach Kategorien",
  categoryDistributionDesc: "Aufschluesselung der Websites ueber alle Hauptkategorien.",
  categoryDistributionDescription: "Anzahl der Websites pro Hauptkategorie",
  categoryDepthCoverage: "Abdeckung der Kategorietiefe",
  categoryDepthCoverageDesc:
    "Verteilung aktiver Websites nach ihrer tiefsten zugewiesenen Kategorieebene.",
  depthLabel: "Tiefe {{depth}}",
  depthMeaning0: "Nur Hauptkategorie",
  depthMeaning1: "Hauptkategorie + 1 Unterkategorie",
  depthMeaning2: "Hauptkategorie + 2 Unterkategorien",
  depthMeaning3: "Hauptkategorie + 3 Unterkategorien",
  depthMeaning4: "Hauptkategorie + 4 Unterkategorien (maximale Tiefe)",
  depthMeaningFallback: "Tiefe {{depth}}",
  avgDepthShort: "Tiefe",
  depthLegendTitle: "Tiefen-Legende (0 bis 4)",
  depthLegendDesc:
    "Die Tiefe beschreibt, wie tief der tiefste zugewiesene Kategoriepfad einer Website ist.",
  depthLegend0: "Tiefe 0: Nur Wurzelkategorie (sehr grobe Zuordnung).",
  depthLegend1: "Tiefe 1: Eine Unterkategorie unterhalb der Wurzel.",
  depthLegend2: "Tiefe 2: Zwei Unterkategorie-Ebenen, genauerer Fit.",
  depthLegend3: "Tiefe 3: Tiefe Spezialisierung im Kategorienbaum.",
  depthLegend4: "Tiefe 4: Maximale unterstuetzte Tiefe (spezifischster Pfad).",
  topCategoriesTitle: "Top Kategorien",
  topCategoriesDescription: "Detaillierte Aufschluesselung nach Kategorien",
  topFederalStates: "Top Bundeslaender",
  federalStatesDescription: "Websites nach Bundesland",
  regionalDistribution: "Regionale Verteilung",
  regionalBreakdown: "Regionale Aufschluesselung",
  regionalBreakdownDesc:
    "Vergleich, wie Websites ueber Bundeslaender und Regionen verteilt sind.",
  layerLabel: "Ebene",
  selectedLayer: "Ausgewaehlte Ebene",
  totalInSelectedLayer: "Websites in ausgewählter Ebene",
  topOnlyLayerHint:
    "Es werden nur die Top {{limit}} {{layer}} nach Website-Anzahl gezeigt.",
  shownVsTotal:
    "Die Top-Liste deckt aktuell {{shown}} von {{total}} Websites in dieser Ebene ab.",
  layer: {
    state: "Bundeslaender",
    administrativeDistrict: "Regierungsbezirke",
    district: "Kreise",
    postalCode: "Postleitzahlen",
  },
  regionalDistributionDescription: "Alle Bundeslaender im Ueberblick",
  currentWeek: "Aktuelle Woche",
  activeUsersTitle: "Aktive Nutzer",
  averages: "Durchschnitte",
  newWebsitesCount: "Neue Websites",
  newUsersCount: "Neue Nutzer",
  categorizations: "Kategorisierungen",
  today: "Heute",
  thisWeek: "Diese Woche",
  thisMonthTitle: "Diesen Monat",
  websitesPerDay: "Websites / Tag",
  categoriesPerWebsiteAvg: "Kat. / Website",
  editsPerDay: "Bearbeitungen / Tag",
  dailyPageviewsTitle: "Gesamtseitenaufrufe pro Tag (letzte 30 Tage)",
  dailyPageviewsDesc: "Taeglich aggregierte Seitenaufrufe.",
  dailyPageviewsFailed: "Taegliche Seitenaufrufe konnten nicht geladen werden.",
  pageviewsLast7Days: "Seitenaufrufe (7 Tage)",
  pageviewsLast30Days: "Seitenaufrufe (30 Tage)",
  avgDailyPageviewsLast7Days: "Durchschnittliche Seitenaufrufe pro Tag (7 Tage)",
  peakPageviewsDay: "Tag mit den meisten Aufrufen",
  peakOnDate: "Am {{date}}",
  rangeLabel: "Zeitraum: {{from}} -> {{to}}",
  pageviewsLabel: "Seitenaufrufe",
  websitesLabel: "Websites",
  categoryLabel: "Kategorie",
  dateLabel: "Datum",
  failedToLoad: "Statistiken konnten nicht geladen werden.",
  monthLabel: "Monat",
  avgCategories: "Durchschnittliche Kategorien",
  perWebsite: "pro Website",
  latestWebsiteAdded: "Zuletzt hinzugefuegte Website",
  latestWebsiteAddedDetail: "Neuester aktiver Website-Eintrag",
  latestUserRegistered: "Letzte Nutzerregistrierung",
  latestUserRegisteredDetail: "Zuletzt registriertes Konto",
  topCategoryNow: "Top-Kategorie aktuell",
  topCategoryShareDetail: "{{share}}% aller Websites ({{count}} Websites)",
  websitesLast7Days: "Neue Websites (7 Tage)",
  websitesLast30DaysLabel: "Neue Websites (30 Tage)",
  usersLast7Days: "Neue Nutzer (7 Tage)",
  usersLast30Days: "Neue Nutzer (30 Tage)",
  previous7Days: "Vorherige 7 Tage",
  categoryTop10: "Top-10 Hauptkategorien (Anteil)",
  categoryTop10Desc:
    "Anteil der Top-10 Hauptkategorien bezogen auf alle Hauptkategorien.",
  others: "Andere",
  noData: "Keine Daten.",
};
export const websiteDetails = {
  title: "Website-Details",
  openWebsite: "Website öffnen",
  loading: "Website-Details werden geladen...",
  failed: "Website-Details konnten nicht geladen werden.",
  categoryPath: "Kategoriepfad",
  regionPath: "Regionspfad",
  metadata: "Details",
  regionMap: "Regionenkarte",
  regionMapUnavailable: "Regionenkarte nicht verfügbar",
  pageviews: "Seitenaufrufe",
  similarWebsites: "Ähnliche Websites",
  similarWebsitesHint: "Verwandte Einträge aus der aktuellen Empfehlungsquelle.",
  noSimilar: "Keine ähnlichen Websites gefunden.",
  similarFailed: "Ähnliche Websites konnten nicht geladen werden.",
  relatedContent: "Verwandte Inhalte",
  relatedContentAdminHint:
    "Zwischen öffentlicher Ähnlichkeitsliste und Forschungswerkzeugen wechseln.",
  similarTab: "Ähnliche",
  researchComparisonTab: "Forschung",
  researchComparisonTitle: "Forschungsvergleich",
  researchComparisonSubtitle:
    "Ranking-Methoden und öffentliche Empfehlungsvorschau prüfen.",
  researchComparisonUnavailable:
    "Der Forschungsvergleich ist für diese Website nicht verfügbar.",
  exportJson: "JSON exportieren",
  methodRankings: "Methoden-Rankings",
  publicPreview: "Öffentliche Vorschau",
  comparisonTable: "Vergleichstabelle",
  dataset: "Datensatz",
  embeddingModel: "Embedding-Modell",
  textFields: "Textfelder",
  hybrid: "Hybrid",
  notConfigured: "nicht konfiguriert",
  noResearchItems: "Keine Methoden-Rankingdaten verfügbar.",
  noPublicPreview: "Keine öffentlichen Vorschau-Einträge verfügbar.",
  websiteColumn: "Website",
  bestRank: "Beste",
  rankSpread: "Spanne",
  hostname: "Hostname",
  url: "Website",
  status: "Status",
  address: "Adresse",
  zipCode: "Postleitzahl",
  region: "Region",
  regionState: "Bundesland",
  regionLayer: "Regionsebene",
  coordinates: "Koordinaten",
  addedAt: "Hinzugefügt",
  addedBy: "Hinzugefügt von",
  openDetails: "Details öffnen",
  showSimilar: "Ähnliche anzeigen",
  hideSimilar: "Ähnliche ausblenden",
};


